<template>
  <div class="slider-sticky-header">
    <div class="calc-continer">
      <div class="float-right header-icon-contain col-12-custom">
        <div class="col-4-custom">
          <a
            @click.prevent.stop="myReturn"
            href="#"
            class="color-red office-location-hide-section"
          >
            <object
              class="svg-back-arrow"
              :data="backSvg"
              type="image/svg+xml"
            ></object>
            <!-- Back -->
          </a>
        </div>
        <div
          class="col-4-custom text-center flex-fill"
          :class="{ 'long-title': longTitle }"
        >
          <a @click.prevent.stop>
            <span class="main-page" v-if="longTitle">Add Appointment</span>
            {{ title }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    myReturn: Function,
    title: String,
    longTitle: Boolean
  },
  computed: {
    backSvg() {
      return require("../../../../../assets/svg/back.svg");
    },
    currentRoute() {
      return this.$router.history.current.name;
    }
  }
};
</script>

<style scoped>
.header-icon-contain {
  display: flex;
}

.col-4-custom {
  width: auto;
  float: unset;
}

.flex-fill {
  flex-grow: 1;
}

.flex-fill a {
  margin-right: 25px;
}

.edit-header {
  border: none;
}

div.long-title a {
  color: #333 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.long-title a .main-page {
  margin-bottom: 6px;
  font-size: 18px;
}
</style>
